import { ChevronDownIcon, DownloadIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface ExportButtonProps {
  disableExportPersona: boolean;
  onExportPersona: () => void;
  onExportConfig: () => void;
}

const ExportButton = (props: ExportButtonProps) => {
  const { disableExportPersona, onExportPersona, onExportConfig } = props;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <DownloadIcon className="mr-1 h-3.5 w-3.5" />
          Export
          <ChevronDownIcon className="ml-1 h-3.5 w-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem
          onClick={onExportPersona}
          disabled={disableExportPersona}
        >
          Persona
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onExportConfig}>
          Signal Weights & Decay Profiles
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportButton;
